import React from 'react';
import Framework from "@beardeddevops/react.framework";
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";
import Market_Place from "components/Objects/MarketPlace";

class MarketPlace extends Framework.Components.View {

	constructor(props) {
		super(props, new API.BuildClass(Types.Accounts_Subscriptions._name, API.RequestType.READ_ALL));
	}

	render() {
		return (
			<div className="container-fluid">
				<Market_Place
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					locations={this.props.rootState.locations}
					states={[]}
				/>
			</div>
		);
	}
}

export default Framework.Components.withRootState(MarketPlace);

